import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import WTWPriceDashboard from './WTWPriceDashboard';

const WTWPriceDashboardScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:WTWPriceDashboard')}>
      <WTWPriceDashboard />
    </PageContent>
  )
}

export default WTWPriceDashboardScreen;